import Loadable from 'react-loadable';
import { Loader } from '../../components';

const AsyncAuthorization = Loadable({
  loader: () => import('./Authorization'),
  loading: Loader,
});

export default AsyncAuthorization;
